import type { PersistenceOptions } from 'pinia-plugin-persistedstate'

/**
 * Pinia persist configuration
 * @param {String} key Name to persist
 * @param {Array} paths Paths to persist
 * @return PersistenceOptions
 */
const piniaPersistConfig = (key: string, paths?: string[]) => {
  const persist: PersistenceOptions = {
    key: (import.meta.env.VITE_LOCAL_STORAGE_PREFIX || '') + key,
    storage: localStorage,
    // storage: sessionStorage,
    pick: paths
  }
  return persist
}

export default piniaPersistConfig
